/* tslint:disable */
/* eslint-disable */
export enum SortOrder {
  Ascending = 'Ascending',
  Descending = 'Descending'
}
